<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>
            <!-- <div class="md-layout">
              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label">
                  PKB No (Read)
                </label>
                <div class="md-layout-item">
                  <validation-provider rules="pkbno" ref="pkb_no" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <md-input v-model="pkb.pkb_no" readonly/>
                  </md-field>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
                </div>
              </div> -->
              
            

             
              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  Tanggal dibuat (Read)
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <validation-provider rules="tanggal" ref="pkb_datetime" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Tanggal Dibuat</label>
                    <md-input v-model="pkb.pkb_datetime" readonly/>
                    <validation-error :errors="apiValidationErrors.pkb_datetime" />
                  </md-field>
                  <span>{{ errors[0] }}</span>
                </validation-provider>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Service Estimate</span><span style="color:red">*</span>
                </label>
                <div class="md-layout-item"> -->
                  <validation-provider rules="serviceestimate" ref="service_estimate" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Service Estimate</label>
                    <md-select v-model="pkb.pkb_service_estimate_id" @md-selected="onChangeServiceEstimate($event)" :readonly="true" required>
                      <md-option v-for="option in options_service_estimate_list" :key="option.value" :value="option.id">
                        {{ option.service_estimate_no }}
                      </md-option>
                    </md-select>
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>
            
              
              <div class="md-layout md-glutter">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Model Car</span>
                </label> -->
                <div class="md-layout-item md-small-size-50">
                  <md-field class="md-invalid">
                    <label for="">Model Car</label>
                    <md-input v-model="pkb.pkb_model_car" readonly/>
                  </md-field>
                </div>
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Plat No</span>
                </label> -->
                <div class="md-layout-item md-small-size-50"> 
                  <md-field class="md-invalid">
                    <label for="">Plat No.</label>
                    <md-input v-model="pkb.pkb_plate_no" readonly/>
                  </md-field>
                </div>
              </div>
              
              <div class="md-layout">
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Color</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-50">
                    <md-field class="md-invalid">
                      <label for="">Color</label>
                      <md-input v-model="pkb.pkb_color" readonly/>
                    </md-field>
                  </div>
                  <!-- <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Bahan Bakar</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-50">
                    <md-field class="md-invalid">
                      <label for="">Bahan Bakar</label>
                      <md-input v-model="pkb.pkb_bahan_bakar" readonly/>
                    </md-field>
                  </div>
                </div>
              
              <div class="md-layout">
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">KM Masuk</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-50">
                    <md-field class="md-invalid">
                      <label for="">KM Masuk</label>
                      <md-input v-model="pkb.pkb_km" readonly/>
                    </md-field>
                  </div>
                  <!-- <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Year</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-50">
                    <md-field class="md-invalid">
                      <label for="">Year</label>
                      <md-input v-model="pkb.pkb_year" readonly/>
                    </md-field>
                  </div>
                </div>

              <div class="md-layout">
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Chasis No</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Chasis No.</label>
                      <md-input v-model="pkb.pkb_chasis_no" readonly/>
                    </md-field>
                  </div>
                  <!-- <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Engine No</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Engine No.</label>
                      <md-input v-model="pkb.pkb_engine_no" readonly/>
                    </md-field>
                  </div>
                </div>
              
              <div class="md-layout">
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Customer Name</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Customer Name</label>
                      <md-input v-model="pkb.pkb_customer_name" readonly/>
                    </md-field>
                  </div>
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Phone No</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Phone No.</label>
                      <md-input v-model="pkb.pkb_phone_no" readonly/>
                    </md-field>
                  </div>
                </div>
              <div class="md-layout">
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Email</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Email</label>
                      <md-input v-model="pkb.pkb_email" readonly/>
                    </md-field>
                  </div>
                <!-- <div class="md-layout">
                  <label class="md-layout-item md-size-15 md-form-label">
                    <span style="color:brown">Alamat</span>
                  </label> -->
                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label for="">Alamat</label>
                      <md-input v-model="pkb.pkb_alamat" readonly/>
                    </md-field>
                  </div>
                </div>
                <br>
            
              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Repeat Order</span><span style="color:red">*</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <validation-provider rules="repeat" ref="pkb_repeat_order" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Repeat Order</label>
                    <md-select v-model="pkb.pkb_repeat_order" required>
                          <md-option value="yes">Yes</md-option>
                          <md-option value="no">No</md-option>
                    </md-select>
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              
              <!-- <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Teknisi</span><span style="color:red">*</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <validation-provider rules="teknisi" ref="pkb_teknisi" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Teknisi</label>
                    <md-select v-model="pkb.pkb_teknisi" required>
                          <md-option v-for="option in options_teknisi_list" :key="option.value" :value="option.id">
                            {{ option.name }}
                          </md-option>
                    </md-select>
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>

              <!-- <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Service Advisor</span><span style="color:red">*</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <div class="md-layout-item md-small-size-50">
                  <md-field class="md-invalid">
                    <label for="">Service Advisor</label>
                    <md-input v-model="pkb.pkb_service_advisor" readonly/>
                  </md-field>
                </div>
                </div>
              </div>

              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Payment Plan</span><span style="color:red">*</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <validation-provider rules="payment" ref="pkb_payment_plan" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Payment Plan</label>
                    <md-select v-model="pkb.pkb_payment_plan" required>
                          <md-option value="cash">Cash</md-option>
                          <md-option value="debit_bca">Debit BCA</md-option>
                          <md-option value="transfer">Transfer</md-option>
                          <md-option value="credit_card">Credit Card</md-option>
                    </md-select>
                  <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              <!-- <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Work Order Type</span><span style="color:red">*</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <validation-provider rules="ordertype" ref="pkb_work_order_type" v-slot="{ errors }">
                  <md-field class="md-invalid">
                    <label for="">Work Order Type</label>
                    <md-select v-model="pkb.pkb_work_order_type" required>
                          <md-option value="fleet">Fleet</md-option>
                          <md-option value="internal">Internal</md-option>
                          <md-option value="reguler">Reguler</md-option>
                          <md-option value="home_service">Home Service</md-option>
                    </md-select>
                    <span class="md-error">{{ errors[0] }}</span>
                  </md-field>
                  </validation-provider>
                </div>
              </div>

              <div class="md-layout" >
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Catatan</span>
                </label> -->
                <div class="md-layout-item md-small-size-100">
                  <md-field class="md-invalid">
                    <label for="">Catatan</label>
                    <md-textarea v-model="pkb.pkb_catatan" md-counter="225" maxlength="225" md-autogrow></md-textarea>
                    <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <!-- <label class="md-layout-item md-size-15 md-form-label">
                  <span style="color:brown">Perintah Kerja</span>
                </label> -->
                <div class="md-layout-item md-small-size-100" style="margin-bottom:30px;">
                  <md-field class="md-invalid">
                    <label for="">Perintah Kerja</label>
                    <md-textarea v-model="pkb.pkb_perintah_kerja" md-counter="225" maxlength="225" md-autogrow></md-textarea>
                    <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar>
                  </md-field>
                </div>
              </div> 
          </md-card-content>
        </md-card>  
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  import {extend} from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
extend('pkbno', {
  ...required,
  message: 'PKB No field is required'
  });
  extend('tanggal', {
  ...required,
  message: 'PKB date field is required'
  });
  extend('serviceestimate', {
  ...required,
  message: 'Service Estimate field is required'
  });
  extend('repeat', {
  ...required,
  message: 'Repeat Order field is required'
  });
  extend('teknisi', {
  ...required,
  message: 'Teknisi field is required'
  });
  extend('payment', {
  ...required,
  message: 'Payment Plan field is required'
  });
  extend('ordertype', {
  ...required,
  message: 'Work Order Type field is required'
  });

export default {
  name: "info-card",

  props: ['pkb'],

  components: { ValidationError },

  mixins: [formMixin],
  
  data() {
    return {
      options_teknisi_list : null,
      options_sa_list : null,
    options_service_estimate_list: [],
    user: null,
    };
  },
created() {
          this.onOpen();
      },
  methods: {
    //fungsi yang berjalan ketika page terbuka
    async onOpen(){
      //set var pkb_datetime dengan data saat page terbuka
      this.pkb.pkb_datetime= this.$moment(new Date()).format('YYYY-MM-DD')
      console.log( this.pkb.pkb_service_estimate_id)
      //check apakah ada nilai pkb_service_estimate_id
      if(this.pkb.pkb_service_estimate_id){
        //jika iya ambil list se yang belum dibuat pkb nya
         await this.$store.dispatch("workshop_service_estimate/get", this.pkb.pkb_service_estimate_id)
          var service_estimate = await this.$store.getters["workshop_service_estimate/service_estimate"]
          this.options_service_estimate_list.push(service_estimate)
          this.onChangeServiceEstimate(this.pkb.pkb_service_estimate_id);
        
        }
        //jika tidak ada ambil list service estimate
        else{
          // await this.$store.dispatch("workshop_service_estimate/list_ada_pkb", false)
           var query = {"filter":{status:"aproved"}}
           await this.$store.dispatch("workshop_service_estimate/list",query);
          this.options_service_estimate_list = await this.$store.getters["workshop_service_estimate/list"]
        }

      //   this.user = await this.$store.getters["profile/me"];
      // if(this.user.pool){
      //   var query_service_advisor = {"filter":{role:'service_advisor',pool:this.pkb.pool}}
      //   var query_teknisi = {"filter":{role:'teknisi',pool:this.pkb.pool}}
      // }
      // else{
      //   var query_service_advisor = {"filter":{role:'service_advisor'}}
      //   var query_teknisi = {"filter":{role:'teknisi'}}
      // }
      // //ambil list user dengan role sa
      // await this.$store.dispatch("users/list",query_service_advisor);
      // this.options_sa_list = await this.$store.getters["users/list"]

        
      //   //ambil list user dengan role teknisi
      //   await this.$store.dispatch("users/list",query_teknisi)
      //   this.options_teknisi_list = await this.$store.getters["users/list"]
      },


      //fungsin berjalan ketika ada perubahan di di select lis service estimate
     async onChangeServiceEstimate(id){
        //console.log(id)

        // //check if options_service_estimate_list is null
        // if(!this.options_service_estimate_list){
        //   //if yes ambil list service estimate yang belum pernah dibuat pkbnya
        //   await this.$store.dispatch("workshop_service_estimate/list_ada_pkb", false)
        //   this.options_service_estimate_list = await this.$store.getters["workshop_service_estimate/list"]

        //    //check apakah page child ini dibuka oleh page edit pkb
        //   if( this.$route.name == "Edit PKB"){
        //     //jika iya set val options_service_estimate_list denga value pkb.pkb_service_estimate
        //   this.options_service_estimate_list.push(this.pkb.pkb_service_estimate)
        //   }
        //   //console.log(this.pkb)
        // } 
        
        
        //cari nomor index dari list options_service_estimate_list yang memiliki id yang sama dengan se yang dipilih
        var indexOption = this.options_service_estimate_list.findIndex(p => p.id == id)
          if(indexOption == -1 && id){
        //ambil data service estimate yang belum ada di list service estimate
         await this.$store.dispatch("workshop_service_estimate/get", this.pkb.pkb_service_estimate_id)
          var service_estimate = await this.$store.getters["workshop_service_estimate/service_estimate"]
          console.log( service_estimate)
          this.options_service_estimate_list.push(service_estimate)
          indexOption = this.options_service_estimate_list.findIndex(p => p.id == id)
        
        }
        
        //set value berdasarkan data yang ada d options_service_estimate_list sesuai dengan nomor index yang di dapatkan sebelumnya
        if(this.options_service_estimate_list[indexOption].service_estimate_vehicle){ 
          this.pkb.pkb_model_car = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_brands.vehicle_brand_name+', '+this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_model+' '+this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_year_model
            if(this.options_service_estimate_list[indexOption].service_estimate_type == 1){
              this.pkb.pkb_plate_no = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_plate_no
              if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 0){
              this.pkb.pkb_color = "Putih"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 1){
                this.pkb.pkb_color = "Putih Kuning"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 2){
                this.pkb.pkb_color = "Putih Metalik"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 3){
                this.pkb.pkb_color = "Hitam"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 4){
                this.pkb.pkb_color = "Hitam Metalik"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 5){
                this.pkb.pkb_color = "Silver"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 6){
                this.pkb.pkb_color = "Silver Metalik"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 7){
                this.pkb.pkb_color = "Abu Abu"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 8){
                this.pkb.pkb_color = "Abu Abu Metalik"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_body_color == 9){
                this.pkb.pkb_color = "Hijau"
              }
              
               
                this.pkb.pkb_year  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_production_year
                this.pkb.pkb_chasis_no  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_chassis_no
                this.pkb.pkb_engine_no  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_engine_no
            }
            else if(this.options_service_estimate_list[indexOption].service_estimate_type == 2){
              this.pkb.pkb_plate_no = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_plate_no
              this.pkb.pkb_year  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_production_year
              this.pkb.pkb_chasis_no  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_chassis_no
              this.pkb.pkb_engine_no  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_engine_no
              this.pkb.pkb_color  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_body_color
              this.pkb.pkb_customer_name  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_name
              this.pkb.pkb_phone_no  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_phone
              this.pkb.pkb_email  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_email
              this.pkb.pkb_alamat  = this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_external_address 
            }
            this.pkb.pkb_service_advisor =  this.options_service_estimate_list[indexOption].service_estimate_service_advisor_name.name;
             
            this.pkb.pool = this.options_service_estimate_list[indexOption].service_estimate_pool.id
            
            this.pkb.pkb_km  = this.options_service_estimate_list[indexOption].service_estimate_vehicle_km
            if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_fuel_type == 1){
                this.pkb.pkb_bahan_bakar = "Bensin"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_fuel_type == 2){
                this.pkb.pkb_bahan_bakar = "Diesel"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_fuel_type == 3){
                this.pkb.pkb_bahan_bakar = "Listrik"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_fuel_type == 4){
                this.pkb.pkb_bahan_bakar = "Hybrid"
              }
              else if(this.options_service_estimate_list[indexOption].service_estimate_vehicle.vehicle_types.vehicle_fuel_type == 5){
                this.pkb.pkb_bahan_bakar = "CNG"
              }
            
      }

        
        //check apakah data client null
        if(this.options_service_estimate_list[indexOption].service_estimate_client != null && this.options_service_estimate_list[indexOption].service_estimate_type == 1){
          //jika tidak isi sesuai data ayang ada di options_service_estimate_list
          this.pkb.pkb_customer_name  = this.options_service_estimate_list[indexOption].service_estimate_client.client_name
          this.pkb.pkb_phone_no  = this.options_service_estimate_list[indexOption].service_estimate_client.client_phone
          this.pkb.pkb_email  = this.options_service_estimate_list[indexOption].service_estimate_client.client_email
          this.pkb.pkb_alamat  = this.options_service_estimate_list[indexOption].service_estimate_client.client_address 
        }
        // else{
        //   //jika null set null
        //   this.pkb.pkb_customer_name  = null
        //   this.pkb.pkb_phone_no  = null
        //   this.pkb.pkb_email  = null
        //   this.pkb.pkb_alamat  = null
        // }
        //this.pkb.pkb_no = "pkb-se-"+this.options_service_estimate_list[indexOption].id
          
        if(!this.options_service_estimate_list[indexOption].service_estimate_pool.warehouse_workshop){
              this.alertWarehouseNotfound(this.options_pool_list[indexOptionList].pool_name)
              return
            } 


        this.$forceUpdate()

        ///send data to parent before send to serviceSparePart child
         this.$emit('keluhanServiceSparepart', { keluhan:this.options_service_estimate_list[indexOption].service_estimate_keluhan, analisa:this.options_service_estimate_list[indexOption].service_estimate_keluhan , service: this.options_service_estimate_list[indexOption].service_estimate_service, part:this.options_service_estimate_list[indexOption].service_estimate_part, warehouse:this.options_service_estimate_list[indexOption].service_estimate_pool.warehouse_workshop.id})
        
         this.getListoptionUser(this.options_service_estimate_list[indexOption].service_estimate_pool.id);
       
      },

      async  getListoptionUser(pool_id){
        // var query_service_advisor = {"filter":{role:'service_advisor',pool:pool_id}}
        var query_teknisi = {"filter":{role:'teknisi',pool:pool_id}}
        
        //ambil list user dengan role sa
        // await this.$store.dispatch("users/list",query_service_advisor);
        // this.options_sa_list = await this.$store.getters["users/list"]

          
          //ambil list user dengan role teknisi
          await this.$store.dispatch("users/list",query_teknisi)
          this.options_teknisi_list = await this.$store.getters["users/list"]
      },

      changeVarServiceEstimateToPkb(){

      },

      async alertWarehouseNotfound(pool_name){
        await this.$store.dispatch(
          "alerts/error",
          "Warehouse workshop for the selected pool "+pool_name+" not found"
        );
        
        // this.service_estimate.service_estimate_pool = null
      },

      //check validasi form
   async validateForm() {
     //conts var baru dengan refrensi input form
    //  const pkb_no = this.$refs['pkb_no'];
      const pkb_datetime = this.$refs['pkb_datetime'];
      const service_estimate = this.$refs['service_estimate'];
      const pkb_repeat_order = this.$refs['pkb_repeat_order'];
      const pkb_teknisi = this.$refs['pkb_teknisi'];
      const pkb_payment_plan = this.$refs['pkb_payment_plan'];
      const pkb_work_order_type = this.$refs['pkb_work_order_type'];
    let result = []
      // result.push(
      //   await pkb_no.validate().then(function(data){
      //     return data.valid
      //   })
      // )

      //add di array result jika validasi benar akan retun true kalau validasi gagal return false
      result.push(
        await pkb_datetime.validate().then(function(data){
          return data.valid
          })
      ) 
      result.push(
        await service_estimate.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await pkb_repeat_order.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await pkb_teknisi.validate().then(function(data){
          return data.valid
        })
      )
 
      result.push(
        await pkb_payment_plan.validate().then(function(data){
          return data.valid
        })
      )
      result.push(
        await pkb_work_order_type.validate().then(function(data){
          return data.valid
        })
      )
      
      return result.every(Boolean)
    }
  },
  

};
</script>

<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
